import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const pblApi = createAsyncThunk(
  "auth/pbls",
  async (data, { rejectWithValue }) => {
    try {
      const paramsData = new URLSearchParams(data);
      const response = await AuthAxios.get(
        apiRoutes.projectBasedList, { params: data }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const pblSlice = createSlice({
  name: "pbl",
  initialState: {
    result: [],
    loading: false,
    error: null,
    message: "",
    total: 0,
  },
  extraReducers: (builder) => {
    builder.addCase(pblApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(pblApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
      state.total = action?.payload?.count;
    });
    builder.addCase(pblApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const pblReducer = pblSlice.reducer;
